import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageSelectorTypeOneComponent } from './language-selector-type-one/language-selector-type-one.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TranslocoModule } from '@jsverse/transloco';
import { UserLanguageEditorComponent } from './user-language-editor/user-language-editor.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { FormControlsModule } from '../forms';
import { LoaderGlobeAnimationDetailComponent } from "../loaders/loader-globe-animation-detail/loader-globe-animation-detail.component";
import { AlertModule } from 'ngx-bootstrap/alert';
import { SurveyProportionEditCardModule } from '../surveys/survey-proportion-edit-card/survey-proportion-edit-card.module';



@NgModule({
  declarations: [
    LanguageSelectorTypeOneComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormControlsModule,
    TypeaheadModule,
    BsDropdownModule,
    TranslocoModule,
    LoaderGlobeAnimationDetailComponent,
    AlertModule,
    SurveyProportionEditCardModule,
    UserLanguageEditorComponent,
],
  exports: [
    LanguageSelectorTypeOneComponent,
  ]
})
export class LanguageModule { }
